<a 
  nz-button 
  nzType="link" 
  [nzDanger]="true"  
  (click)="showMore()" 
  [routerLink]="link || null"
>
  @if (prefixIcon) {
    <svg-icon
      class="prefix pointing-arrow-icon"
      [src]="iconsPath + prefixIcon"
    ></svg-icon>
  }
  <span>{{ label }}</span>
  @if (suffixIcon) {
    <svg-icon
      class="suffix pointing-arrow-icon"
      [src]="iconsPath + suffixIcon"
    ></svg-icon>
  }
</a>
